import { cn } from '@/lib/utils';

/**
 * The Bramble mark: three berries on a thorned stem. Drawn, not imported —
 * it inherits currentColor so it works in both themes and at any size.
 */
export function BrambleMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className={cn('size-7', className)}
      role="presentation"
    >
      <path
        d="M16 30V17.5C16 12 12.5 8.5 7 7"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path d="M11.4 13.2 8.2 11.6M13.8 17.6l-3.4.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path
        d="M16 17.5c4.2-.6 6.8-3 7.6-7.2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="20.4" cy="6.4" r="3.5" className="fill-berry" />
      <circle cx="25.6" cy="9.4" r="2.6" className="fill-berry" opacity="0.75" />
      <circle cx="22.6" cy="13.4" r="2.1" className="fill-berry" opacity="0.55" />
    </svg>
  );
}
